import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter, useRoute } from 'vue-router'
import i18n from '@/i18n'
import { findRouteByPath, localizedPath } from '@/router/localeRoutes'

export function useLanguage() {
  const { t } = useI18n()
  const router = useRouter()
  const route = useRoute()

  const language = computed(() => i18n.global.locale.value)

  function setLanguage(lang) {
    i18n.global.locale.value = lang
    try {
      localStorage.setItem('lang', lang)
    } catch {
      // ignore in SSR / restricted environments
    }
  }

  // If the current page has a real translated URL, navigate there — the URL
  // is the source of truth for language on those pages (see router guard).
  // Otherwise fall back to flipping the locale in place, same as before.
  function toggleLanguage() {
    const target = language.value === 'en' ? 'ro' : 'en'
    const match = route ? findRouteByPath(route.path) : null
    const targetPath = match ? localizedPath(match.name, target) : null

    if (targetPath && targetPath !== route.path) {
      setLanguage(target)
      router.push(targetPath)
      return
    }
    setLanguage(target)
  }

  return { t, language, setLanguage, toggleLanguage }
}
